// ⚠️ FICHIER GÉNÉRÉ — ne pas éditer ici. Source : shared/ui/ · régénérer avec `bash shared/sync.sh`
'use client';
// Frontière client du socle `urlsModules`. Ce fichier ne contient AUCUNE
// logique : il ne fait que marquer « use client » sur le fournisseur et le
// hook, que `urlsModules.tsx` définit.
//
// Pourquoi séparer : `urlsModules.tsx` exporte aussi `lireUrlsModules()`, que
// des composants SERVEUR appellent (layouts, robots.ts, sitemap.ts). Un module
// portant « use client » ne peut pas être appelé depuis le serveur — ses
// exports n'y sont que des références vers le paquet client. Marquer la
// frontière ici laisse `lireUrlsModules` appelable côté serveur tout en
// donnant au fournisseur son statut de composant client.
export { FournisseurUrlsModules, useUrlsModules } from './urlsModules';
export type { UrlsModules } from './urlsModules';
